import request from '@/modules/base/util/request'

import config from '@/config'
import { sanitizeListColumns } from '@/redux/util/sanitizeListColumns'
import ClientListColumnModel from '@/modules/client/components/list/models/client-list-column-model'
import clientConfig from '@/modules/client/config'

import {
  updateQuickCounter,
  updatePagination,
  listError,
  settingsError,
  settingsUpdate,
  settingsLoading,
  settingsLoadingFinished,
  toggleSettingModal,
  LIST_TYPES,
  dispatch,
  getList,
  setShallRefresh,
  QUERY_TYPES,
  fetchCounter,
} from '@/redux/ducks/lists'
import ClientListModel from '@/modules/client/components/list/models/client-list-model'

const { CLIENT_LIST_TYPE } = LIST_TYPES

export const updateColumnSort = (data) => {
  return (dispatch) => {
    const sendRequest = request(`${clientConfig.clientListSetting}/sort`, {
      auth: true,
      method: 'PUT',
      data: data.filter(item => item.name),
    })

    sendRequest
      .catch((error) => dispatch(settingsError(CLIENT_LIST_TYPE, error)))
  }
}

export const updateColumnSetting = (data, updateFromSettingModal) => {
  return (dispatch) => {
    const sendRequest = request(`${clientConfig.clientListSetting}/columns`, {
      auth: true,
      method: 'PUT',
      data: data.filter(item => item.label && item.name),
    })

    dispatch(settingsLoading(CLIENT_LIST_TYPE))

    sendRequest
      .then((response) => {
        dispatch(settingsLoadingFinished(CLIENT_LIST_TYPE))
        if (updateFromSettingModal) {
          dispatch(toggleSettingModal(CLIENT_LIST_TYPE, false))
          dispatch(fetchListSetting())
        }
      })
      .catch((error) => {
        dispatch(settingsError(CLIENT_LIST_TYPE, error))
      })
  }
}

export const fetchListSetting = () => {
  return (dispatch) => {
    dispatch(settingsLoading(CLIENT_LIST_TYPE))
    request(clientConfig.clientListSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { autoSizeColumns, columns },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const clientColumns = sanitizedColumns.map((column) => {
          column.displayed = true
          column.hide = !column.active

          return new ClientListColumnModel(column)
        })

        dispatch(settingsUpdate(CLIENT_LIST_TYPE, { autoSizeColumns, columns: clientColumns }))
      })
      .catch((error) => {
        dispatch(settingsError(CLIENT_LIST_TYPE, error))
      })
  }
}

export const fetchList = (params) => {
  const url = `${clientConfig.routes.list}`
  const { searchTerm, quickFilter, filterItems, fetchCounters } = getList(CLIENT_LIST_TYPE)
  const { request: requestData } = params
  const dataToSend = {
    ...requestData,
    filterModel: { ...requestData.filterModel, ...quickFilter },
    filterItems,
    searchTerm,
    queryType: QUERY_TYPES.DATA,
  }
  return request(url, {
    method: 'POST',
    auth: true,
    isConcurrent: true,
    timeout: config.requestExtraLongTimeout,
    data: dataToSend,
  })
    .then(response => {
      const { data, meta } = response.body
      dispatch(updatePagination(CLIENT_LIST_TYPE, meta))
      dispatch(updateQuickCounter(CLIENT_LIST_TYPE, meta))
      const transformed = data.map(item => new ClientListModel(item))
      params.successCallback(transformed, meta.count)
      if (fetchCounters) {
        fetchCounter(CLIENT_LIST_TYPE, url, dataToSend)
      }
      return { data: transformed, meta }
    })
    .catch((error) => {
      dispatch(listError(CLIENT_LIST_TYPE, error))
      // ag-grid expects (rowData, lastRow): an empty result ends the loading row and the list shows its no rows overlay.
      // params.fail() would leave the loading row behind without telling the user anything
      params.successCallback([], 0)
      return { data: [], meta: { count: 0 } }
    })
}

export const refreshList = () => {
  dispatch(setShallRefresh(CLIENT_LIST_TYPE, true))
}
